import { Bell, X } from "lucide-react";

export default function NotificationBar({ alerts, onDismiss }) {
  if (!alerts.length) return null;

  return (
    <div className="space-y-2" data-testid="notification-bar">
      {alerts.map((a) => (
        <div
          key={a.id}
          data-testid={`notification-${a.id}`}
          className={`flex items-center justify-between gap-4 border px-4 py-3 ${
            a.type === "sale"
              ? "border-ochre/60 bg-oxblood/30"
              : "border-line bg-elevated"
          }`}
        >
          <p className="flex items-center gap-2.5 text-sm text-bone min-w-0">
            <Bell size={13} className={`shrink-0 ${a.type === "sale" ? "text-ochre" : "text-gold"}`} />
            <span className="truncate">{a.text}</span>
          </p>
          <button
            onClick={() => onDismiss(a.id)}
            data-testid={`notification-dismiss-${a.id}`}
            aria-label="Dismiss notification"
            className="text-mute hover:text-bone transition-colors shrink-0"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
